import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';

export const useDeleteModuleV2 = () => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (moduleId: string) => service.deleteModule(moduleId),
    onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['adminModuleListV2'] }),
  });
};
